import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=50914f52&scoped=true"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=50914f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50914f52",
  null
  
)

export default component.exports